import './accordion.css';

export default function Accordion({ label, description, enabled, onClick, cookie }) {
  return (
    <div className="accordion">
      <details>
        <summary>
          <div className="summary_header">
            <div className="summary-left">
              <span className="arrow">▶</span>
              <span>{label}</span>
            </div>
            {enabled ? (
              <span className="status">Always Active</span>
            ) : (
              <span onClick={onClick} className="status">
                <input type="checkbox" id="toggle" className="offscreen" />
                <label htmlFor="toggle" className="switch" />
              </span>
            )}
          </div>
          <div className="description">{description}</div>
        </summary>
        <div className="cookie-section">
          <div className="cookie-entry">
            {cookie.map((options) => (
              <div className="cookie_items" key={options.id}>
                <div className="cookie_entry_items">
                  <div className="label">
                    Cookie <span />
                  </div>
                  <div className="cookie_label1">{options?.name}</div>
                </div>
                <div className="cookie_entry_items">
                  <div className="label">Duration</div>
                  <div className="cookie_label2">{options?.duration}</div>
                </div>
                <div className="cookie_entry_items">
                  <div className="label">Description</div>
                  <div className="cookie_label3">{options?.description}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </details>
    </div>
  );
}
